<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Avaliar fatores de risco"
    >
        <rkm-alert class="mt-0 mb-3">
            Um fator de risco é considerado como <strong>presente</strong> quando este estiver associado a problemas no desenvolvimento da criança.
        </rkm-alert>

        <rkm-form ref="RkmForm">
            <rkm-table
                :fields="fields"
                :items="model"
                hide-filters
                hide-pagination
            >
                <template v-slot:cell(resposta)="{item}">
                    <rkm-form-radio-group
                        :disabled="readonly"
                        v-model="item.isPresente"
                    >
                        <rkm-form-radio
                            :disabled="item.isRespondido"
                            :value="null"
                        >
                            Não informado
                        </rkm-form-radio>

                        <rkm-form-radio :value="false">Ausente</rkm-form-radio>
                        <rkm-form-radio :value="true">Presente</rkm-form-radio>
                    </rkm-form-radio-group>
                </template>
            </rkm-table>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                v-if="!readonly"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {object} from '@/mixins'

export default {
    data: () => ({
        fields: [
            {key: 'descricao', label: 'Pergunta'},
            {key: 'status', label: 'Status'},
            {class: 'col-min', key: 'resposta', label: 'Resposta'},
        ],
        items: null,
        model: null,
    }),
    methods: {
        open(items) {
            this.items = items

            this.edit()

            this.$refs.RkmModal.show()
        },
        edit() {
            this.resetForm()

            this.model = this.clone(this.items)
        },
        update() {
            this.data.model.puericultura.fatoresRisco = this.model
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.update()

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model = null
        },
    },
    mixins: [object],
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, default: false},
    },
}
</script>